// extracted by mini-css-extract-plugin
export default {"card":"ProfileCard_card__NOsjN","form":"ProfileCard_form__JkcQg","actions":"ProfileCard_actions__+7VN5"};